/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function ShowHeader({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M14.138 8.218a.6.6 0 0 1 .925.764l-4.787 6a.6.6 0 0 1-.904.024l-2.214-2.5a.6.6 0 1 1 .884-.812l1.748 1.993zM12.5.9a2.6 2.6 0 0 1 2.6 2.6v2.165c0 .454-.652.687-1.008.406a.49.49 0 0 1-.192-.383V3.5a1.4 1.4 0 0 0-1.4-1.4h-9a1.4 1.4 0 0 0-1.4 1.4v9a1.4 1.4 0 0 0 1.4 1.4h2.4a.6.6 0 1 1 0 1.2H3.5a2.6 2.6 0 0 1-2.6-2.6v-9A2.6 2.6 0 0 1 3.5.9zM12 3.4a.6.6 0 1 1 0 1.2H4a.6.6 0 1 1 0-1.2z" /></svg>;
}
;